import Layout from '@/page/index/';
import staticChild from '@/router/views/index'; // 固定页面（首页等）

/**
 * 静态基础路由：任何时候都存在，不依赖后端数据。
 * 后端返回的菜单（order_list）由 router.js 在登录后通过 addRoutes 动态挂载。
 */
export default [
  {
    path: '/login',
    name: '登录页',
    component: () => import(/* webpackChunkName: "page" */ '@/page/login/index'),
  },
  {
    path: '/create',
    name: '數據生成',
    component: () => import(/* webpackChunkName: "page" */ '@/page/login/creatData'),
  },
  {
    path: '/desk',
    name: '首页',
    component: Layout,
    children: [...staticChild],
    redirect: '/index',
  },
];



// WEBPACK FOOTER //
// ./src/router/page/index.js